import * as types from 'syft-acp-core/actions/action-types'

export function fetchDeletedRTWDocuments(workerId) {
  return { type: types.DELETED_RTW_DOCUMENTS_FETCH_BEGIN, workerId }
}
